import { render, staticRenderFns } from "./KPIProyectoNuevo.vue?vue&type=template&id=561f19c7&"
import script from "./KPIProyectoNuevo.vue?vue&type=script&lang=js&"
export * from "./KPIProyectoNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports